import axios from 'axios';
import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useUploadGroupFile = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const uploadFile = (file, groupGuid, closeModal) => {
    setLoading(true);

    const formData = new FormData();
    formData.append('GroupGuid', groupGuid ?? '');
    formData.append('File', file);

    axiosClient
      .post(`SettingProduct/CoddingAttribute/InsertFromExcel`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(res?.data?.message, { variant: 'success' });
          closeModal();
        } else {
          enqueueSnackbar(res?.data?.message, { variant: 'error' });
          setLoading(false);
        }
      })
      .catch(err => {
        enqueueSnackbar(err?.message, { variant: 'error' });
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return [uploadFile];
};

export default useUploadGroupFile;
